// src/pages/Login.js
import { useState, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import API from '../api/api';
import {
  Avatar,
  Button,
  TextField,
  Grid,
  Paper,
  Typography,
  FormControlLabel,
  Checkbox,
  Box,
  InputAdornment,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import { useSnackbar } from '../contexts/SnackbarContext';

export default function Login() {
  const { login } = useContext(AuthContext);
  const { showSnackbar } = useSnackbar();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await API.post('/auth/login', { username, password });
      login(
        { id: res.data.id, username: res.data.username, role: res.data.role },
        res.data.token
      );
    } catch (err) {
      showSnackbar(err.response?.data?.message || 'Connexion echouee', 'error');
    }
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: '100vh',
        background: 'var(--app-bg)',
      }}
    >
      <Grid item xs={10} sm={6} md={4}>
        <Paper
          elevation={12}
          sx={{
            padding: 4,
            borderRadius: 3,
            textAlign: 'center',
            backgroundColor: 'var(--surface-1)',
            border: '1px solid var(--border-subtle)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
            <Avatar
              sx={{
                bgcolor: 'transparent',
                width: 56,
                height: 56,
                mb: 2,
                border: '2px solid var(--text-primary)',
              }}
            >
              <PersonIcon sx={{ fontSize: 32, color: 'var(--text-primary)' }} />
            </Avatar>
            <Typography variant="h5" sx={{ color: 'var(--text-primary)', fontWeight: 'bold' }}>
              CONNEXION
            </Typography>
          </Box>

          <form onSubmit={handleSubmit}>
            <TextField
              placeholder="Nom d'utilisateur"
              variant="standard"
              fullWidth
              margin="normal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonIcon sx={{ color: 'var(--text-primary)' }} />
                  </InputAdornment>
                ),
                style: { color: 'var(--text-primary)' },
              }}
              sx={{
                '& .MuiInput-underline:before': { borderBottomColor: 'var(--text-primary)' },
                '& .MuiInput-underline:after': { borderBottomColor: 'var(--text-primary)' },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                  borderBottomColor: 'var(--text-primary)',
                },
              }}
            />

            <TextField
              placeholder="Mot de passe"
              type="password"
              variant="standard"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon sx={{ color: 'var(--text-primary)' }} />
                  </InputAdornment>
                ),
                style: { color: 'var(--text-primary)' },
              }}
              sx={{
                '& .MuiInput-underline:before': { borderBottomColor: 'var(--text-primary)' },
                '& .MuiInput-underline:after': { borderBottomColor: 'var(--text-primary)' },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                  borderBottomColor: 'var(--text-primary)',
                },
              }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                  sx={{ color: 'var(--text-primary)' }}
                />
              }
              label={<Typography sx={{ color: 'var(--text-primary)' }}>Se souvenir de moi</Typography>}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                mt: 3,
                borderRadius: 20,
                bgcolor: '#ffffff',
                color: '#6a11cb',
                fontWeight: 'bold',
                '&:hover': { bgcolor: '#e0e0e0' },
              }}
            >
              Connexion
            </Button>

            <Typography sx={{ mt: 2, color: 'var(--text-primary)', cursor: 'pointer' }}>
              Mot de passe oublie ?
            </Typography>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
}




